import type { TelegramWidgetUser } from './contracts.ts'

const FIELDS = ['id', 'first_name', 'last_name', 'username', 'photo_url', 'auth_date', 'hash'] as const

/**
 * Данные Telegram Login Widget после редиректа (`data-auth-url`): Telegram дописывает их в query.
 * Подпись покрывает ровно присланные поля, поэтому лишнего не добавляем и пустое не выдумываем.
 */
export function readWidgetRedirect(search: string): TelegramWidgetUser | null {
  const params = new URLSearchParams(search)
  const id = Number(params.get('id'))
  const authDate = Number(params.get('auth_date'))
  const firstName = params.get('first_name')
  const hash = params.get('hash')
  if (!Number.isSafeInteger(id) || id <= 0 || !Number.isSafeInteger(authDate) || firstName === null || hash === null) {
    return null
  }
  const user: TelegramWidgetUser = { id, first_name: firstName, auth_date: authDate, hash }
  const lastName = params.get('last_name')
  const username = params.get('username')
  const photoUrl = params.get('photo_url')
  if (lastName !== null) user.last_name = lastName
  if (username !== null) user.username = username
  if (photoUrl !== null) user.photo_url = photoUrl
  return user
}

/** Тот же query без полей виджета: чтобы данные входа не оставались в адресной строке и истории. */
export function stripWidgetParams(search: string): string {
  const params = new URLSearchParams(search)
  for (const field of FIELDS) params.delete(field)
  const rest = params.toString()
  return rest === '' ? '' : `?${rest}`
}
